// Vendors
import {
  TrackingEventsEnum,
  TrackingLinkEventReturnType,
  TrackingViewEventReturnType,
} from '@openbank/ziniaweb-ui-core-models';
// Types
import { TrackBuilderType } from 'types/track-builder.type';
import { ConsentsCheckboxChangeTrackingBuilder } from './types/pre-contract.view.handlers.types';
import { PreContractualTrackingHandlersType } from './types/pre-contract.view.tracking.handlers.type';

const preContractPageDisplayedTracking = (): TrackingViewEventReturnType => ({
  payload: {
    pageName: '/signAndPayment/step_4',
    sectionFamily: 'customer',
    sectionCategory: 'orders',
    sectionName: 'lending',
    interactionType: 'funnel',
    serviceType: 'userSettings',
    processType: 'signAndPayment',
    processStep: 'step_4',
  },
  type: TrackingEventsEnum.VIEW,
});

const continueButtonClickTracking = (): TrackingLinkEventReturnType => ({
  payload: {
    action: 'continue',
    format: 'button',
    component: 'form',
    element: 'continue',
    pathname: '/',
    eventCategory: 'PreContract',
    eventAction: 'clickButton',
    eventLabel: 'continueButton',
  },
  type: TrackingEventsEnum.LINK,
});

const editIbanButtonClickTracking = (): TrackingLinkEventReturnType => ({
  payload: {
    action: 'edit',
    format: 'pencil',
    component: 'form',
    element: 'paymentMethod',
    eventCategory: 'PreContract',
    eventAction: 'clickEdit',
    eventLabel: 'editPaymentMethod',
  },
  type: TrackingEventsEnum.LINK,
});

const downloadPdfButtonClickTracking = (): TrackingLinkEventReturnType => ({
  payload: {
    action: 'download',
    format: 'link',
    component: 'form',
    element: 'termsAndConditions',
    pathname: '/',
    eventCategory: 'PreContract',
    eventAction: 'clickLink',
    eventLabel: 'termsAndConditionsLink',
  },
  type: TrackingEventsEnum.LINK,
});

const preContractConsentCheckboxChangeTracking = ({
  checked,
}: ConsentsCheckboxChangeTrackingBuilder): TrackingLinkEventReturnType => {
  return {
    payload: {
      action: checked ? 'check' : 'uncheck',
      format: 'checkBox',
      component: 'form',
      element: 'CONSENT',
      eventCategory: 'PreContract',
      eventAction: 'clickCheckBox',
      eventLabel: `precontractualInformation${checked ? 'check' : 'uncheck'}`,
    },
    type: TrackingEventsEnum.LINK,
  };
};

const PreContractTrackingHandlers = (
  track: TrackBuilderType
): PreContractualTrackingHandlersType => ({
  handleEditIbanButonClickTracking: () => track(editIbanButtonClickTracking()),
  handlePreContractPageDisplayedTracking: () => track(preContractPageDisplayedTracking()),
  handleContinueButtonClickTracking: () => track(continueButtonClickTracking()),
  handleDownloadPdfButtonClickTracking: () => track(downloadPdfButtonClickTracking()),
  handleConsentsCheckboxChangeTracking: ({
    checked,
    type,
  }: ConsentsCheckboxChangeTrackingBuilder) =>
    track(preContractConsentCheckboxChangeTracking({ checked, type })),
});

export { PreContractTrackingHandlers };
